import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from 'common/components/form/inputs/Select';

import { useActions } from 'utils/hooks';
import * as listActions from 'store/lists/actions';

const JobLogTypesSelector = ({ filter, value, onChange, label, placeholder }) => {
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);
  const jobLogTypes = useSelector(state => state.lists['job-log-types']);

  useEffect(() => {
    if (!jobLogTypes.options.length) fetchListOptions('job-log-types');
  }, []);

  return (
    <Select
      label={label}
      placeholder={placeholder ? placeholder : 'Select value'}
      getOptionValue={option => option.job}
      getOptionLabel={option => option.job}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      options={jobLogTypes.options}
      isMulti={true}
      onChange={selected =>
        onChange({
          data: selected ? selected : [],
          value: selected ? selected : ''
        })
      }
      isClearable
    />
  );
};

export default JobLogTypesSelector;
